<script setup lang="ts">
import { computed, inject, type Ref } from 'vue';
import { type PatientMetricsSummary } from '@/api/patient-monthly-metrics';
import { type SerializedUser } from '@/api/users';

const props = defineProps<{
  patient: PatientMetricsSummary;
}>();

const currentUser = inject<Ref<SerializedUser>>('currentUser');

const showGroups = computed(() => !!currentUser?.value?.companyGroupsEnabled);
const showCategories = computed(() =>
  !!currentUser?.value?.companyPatientServiceCategoriesEnabled);

const categoryText = computed(() => {
  if (!props.patient.serviceCategoryName) return 'Sin categoría';

  return props.patient.serviceSubcategoryName ?
    `${props.patient.serviceCategoryName} • ${props.patient.serviceSubcategoryName}` :
    props.patient.serviceCategoryName;
});
</script>

<template>
  <v-card
    class="pa-4 mb-4"
    :elevation="1"
    data-testid="patient-summary-card"
  >
    <div class="d-flex flex-wrap align-center ga-2">
      <span class="text-subtitle-1 font-weight-bold">
        {{ patient.fullName }}
      </span>
      <span class="text-body-2 text-medium-emphasis">
        RUT: {{ patient.dni || '—' }}
      </span>
      <template v-if="showGroups">
        <v-chip
          v-for="name in patient.groupNames"
          :key="name"
          size="small"
          variant="outlined"
          prepend-icon="mdi-account-group"
          label
        >
          {{ name }}
        </v-chip>
      </template>
      <v-chip
        v-if="showCategories"
        size="small"
        color="primary"
        variant="tonal"
        label
      >
        {{ categoryText }}
      </v-chip>
    </div>
  </v-card>
</template>
